"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableHeaderSelectionBehavior = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var bc_data_table_header_paginator_behavior_1 = require("./bc-data-table-header-paginator-behavior");
var BcDataTableHeaderSelectionBehavior = (function () {
    function BcDataTableHeaderSelectionBehavior(bcDataTableConfig) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.headerActionsCb = null;
        this.selectionActionMap = {
            button: this.createButtonAction.bind(this),
            link: this.createLinkAction.bind(this),
        };
        this.bcDataTableHeaderPaginatorBehavior = new bc_data_table_header_paginator_behavior_1.BcDataTableHeaderPaginatorBehavior(this.bcDataTableConfig);
        if (bcDataTableConfig.actions && bcDataTableConfig.actions.headerAction) {
            this.headerActionsCb = bcDataTableConfig.actions.headerAction;
        }
    }
    BcDataTableHeaderSelectionBehavior.prototype.callHeaderActions = function (_rows, object) {
        if (this.headerActionsCb) {
            this.headerActionsCb(_rows, object);
        }
    };
    BcDataTableHeaderSelectionBehavior.prototype.init = function (headerDiv) {
        var selectionDivContainer = headerDiv.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_CLASS)[0];
        this.createSelectionActionsDivContainer(selectionDivContainer);
        this.createSelectionInfoDivContainer(selectionDivContainer);
    };
    BcDataTableHeaderSelectionBehavior.prototype.createSelectionInfoDivContainer = function (selectionDivContainer) {
        var selectionInfoDivContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        selectionInfoDivContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_INFO_CONTAINER_CLASS);
        var selectedContainer = this.createSelectionSelectedDivContainer();
        selectionInfoDivContainer.append(selectedContainer);
        var restartContainer = this.createSelectionRestartDivContainer();
        selectionInfoDivContainer.append(restartContainer);
        selectionDivContainer.appendChild(selectionInfoDivContainer);
    };
    BcDataTableHeaderSelectionBehavior.prototype.createSelectionRestartDivContainer = function () {
        var selectionActionsDivContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        selectionActionsDivContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_RESTART_CLASS);
        var selectionRestartButton = this.getSelectionRestartButton();
        selectionActionsDivContainer.appendChild(selectionRestartButton);
        return selectionActionsDivContainer;
    };
    BcDataTableHeaderSelectionBehavior.prototype.getSelectionRestartButton = function () {
        var selectionRestartButton = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        selectionRestartButton.classList.add(bc_data_table_constants_1.BcDataTableConstansts.BC_BUTTON_CLASS);
        selectionRestartButton.classList.add(bc_data_table_constants_1.BcDataTableConstansts.BC_BUTTON_GHOST_CLASS);
        var selectionRestartButtonSpan = this.getSelectionRestartButtonSpan();
        selectionRestartButton.appendChild(selectionRestartButtonSpan);
        selectionRestartButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.handleRestartClick.bind(this));
        return selectionRestartButton;
    };
    BcDataTableHeaderSelectionBehavior.prototype.handleRestartClick = function (event) {
        this.onRestartClicked(event);
    };
    BcDataTableHeaderSelectionBehavior.prototype.getSelectionRestartButtonSpan = function () {
        var _a;
        var buttonText = ((_a = this.bcDataTableConfig.header.selection) === null || _a === void 0 ? void 0 : _a.restartText) || bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_RESTART_BUTTON_DEFAULT_TEXT;
        var selectionRestartSpan = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        selectionRestartSpan.textContent = buttonText;
        return selectionRestartSpan;
    };
    BcDataTableHeaderSelectionBehavior.prototype.createSelectionSelectedDivContainer = function () {
        var selectionSelectedDivContainer = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        selectionSelectedDivContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_SELECTED_CLASS);
        var selectionSelectedLabel = this.getSelectionSelectedLabel();
        selectionSelectedDivContainer.appendChild(selectionSelectedLabel);
        return selectionSelectedDivContainer;
    };
    BcDataTableHeaderSelectionBehavior.prototype.getSelectionSelectedLabel = function () {
        var selectionSelectedLabel = document.createElement(common_constants_1.BcCommonConstants.LABEL_TAG);
        selectionSelectedLabel.textContent = bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_DEFAULT_NO_ELEMENTS_SELECTED;
        this.selectionSelectedLabel = selectionSelectedLabel;
        return this.selectionSelectedLabel;
    };
    BcDataTableHeaderSelectionBehavior.prototype.updateSelectionSelectedLabel = function (dataTableElement) {
        if (this.bcDataTableConfig.multicheck && this.bcDataTableConfig.header) {
            var previousElement = dataTableElement.previousElementSibling;
            var elementSelectedDivContainer = previousElement.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_SELECTED_CLASS)[0];
            var selectionSelectedLabel = elementSelectedDivContainer.getElementsByTagName(common_constants_1.BcCommonConstants.LABEL_TAG)[0];
            var amountItemsSelected = this.getAmountItemsSelected();
            var elementText = this.getElementText(amountItemsSelected);
            var selectedText = this.getSelectedText(amountItemsSelected);
            selectionSelectedLabel.textContent = "".concat(amountItemsSelected, " ").concat(elementText, " ").concat(selectedText);
        }
    };
    BcDataTableHeaderSelectionBehavior.prototype.getElementText = function (amountItemsSelected) {
        var _a, _b, _c;
        if ((_a = this.bcDataTableConfig.header) === null || _a === void 0 ? void 0 : _a.selection) {
            var selectedConfig = (_c = (_b = this.bcDataTableConfig.header) === null || _b === void 0 ? void 0 : _b.selection) === null || _c === void 0 ? void 0 : _c.selected;
            if (amountItemsSelected > 1) {
                return (selectedConfig === null || selectedConfig === void 0 ? void 0 : selectedConfig.elementPlural) || bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_DEFAULT_PLURAL_ELEMENT_TEXT;
            }
            return (selectedConfig === null || selectedConfig === void 0 ? void 0 : selectedConfig.elementSingular) || bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_DEFAULT_SINGULAR_ELEMENT_TEXT;
        }
        else {
            if (amountItemsSelected > 1) {
                return bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_DEFAULT_PLURAL_ELEMENT_TEXT;
            }
            else {
                return bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_DEFAULT_SINGULAR_ELEMENT_TEXT;
            }
        }
    };
    BcDataTableHeaderSelectionBehavior.prototype.getSelectedText = function (amountItemsSelected) {
        var _a, _b, _c;
        if ((_a = this.bcDataTableConfig.header) === null || _a === void 0 ? void 0 : _a.selection) {
            var selectedConfig = (_c = (_b = this.bcDataTableConfig.header) === null || _b === void 0 ? void 0 : _b.selection) === null || _c === void 0 ? void 0 : _c.selected;
            if (amountItemsSelected > 1) {
                return (selectedConfig === null || selectedConfig === void 0 ? void 0 : selectedConfig.selectedPlural) || bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_DEFAULT_PLURAL_SELECTED_TEXT;
            }
            return (selectedConfig === null || selectedConfig === void 0 ? void 0 : selectedConfig.selectedSingular) || bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_DEFAULT_SINGULAR_SELECTED_TEXT;
        }
        else {
            if (amountItemsSelected > 1) {
                return bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_DEFAULT_PLURAL_SELECTED_TEXT;
            }
            else {
                return bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_DEFAULT_SINGULAR_SELECTED_TEXT;
            }
        }
    };
    BcDataTableHeaderSelectionBehavior.prototype.createSelectionActionsDivContainer = function (selectionDivContainer) {
        var _a, _b;
        var header = document.createElement(common_constants_1.BcCommonConstants.HEADER_TAG);
        header.className = bc_data_table_constants_1.BcDataTableConstansts.TABS_GROUP;
        header.id = bc_data_table_constants_1.BcDataTableConstansts.TABS_ID;
        var nav = document.createElement(common_constants_1.BcCommonConstants.NAV_TAG);
        nav.className = bc_data_table_constants_1.BcDataTableConstansts.TAB_HEADER_CLASS;
        var ul = document.createElement(common_constants_1.BcCommonConstants.UL_TAG);
        ul.className = bc_data_table_constants_1.BcDataTableConstansts.TAB_CONTAINER_CLASS;
        ul.setAttribute(common_constants_1.BcCommonConstants.ROLE, bc_data_table_constants_1.BcDataTableConstansts.TABLIST_ROLE);
        if ((_b = (_a = this.bcDataTableConfig.header) === null || _a === void 0 ? void 0 : _a.selection) === null || _b === void 0 ? void 0 : _b.actions) {
            this._createActions(ul);
        }
        var arrowButtonsDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        arrowButtonsDiv.className = bc_data_table_constants_1.BcDataTableConstansts.ARROW_BUTTONS;
        var prevButton = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        prevButton.className = bc_data_table_constants_1.BcDataTableConstansts.PREV_CLASS + ' ' + bc_data_table_constants_1.BcDataTableConstansts.TAB_BUTTONS_CLASS;
        var prevIcon = document.createElement(common_constants_1.BcCommonConstants.I_TAG);
        prevIcon.className = bc_data_table_constants_1.BcDataTableConstansts.ICON_CLASS;
        prevIcon.textContent = bc_data_table_constants_1.BcDataTableConstansts.TAB_ICON_LEFT_CLASS;
        prevButton.appendChild(prevIcon);
        var nextButton = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        nextButton.className = bc_data_table_constants_1.BcDataTableConstansts.NEXT_CLASS + ' ' + bc_data_table_constants_1.BcDataTableConstansts.TAB_BUTTONS_CLASS;
        var nextIcon = document.createElement(common_constants_1.BcCommonConstants.I_TAG);
        nextIcon.className = bc_data_table_constants_1.BcDataTableConstansts.ICON_CLASS;
        nextIcon.textContent = bc_data_table_constants_1.BcDataTableConstansts.TAB_ICON_RIGHT_CLASS;
        nextButton.appendChild(nextIcon);
        arrowButtonsDiv.appendChild(prevButton);
        arrowButtonsDiv.appendChild(nextButton);
        nav.appendChild(ul);
        nav.appendChild(arrowButtonsDiv);
        header.appendChild(nav);
        selectionDivContainer.appendChild(header);
    };
    BcDataTableHeaderSelectionBehavior.prototype._createActions = function (ul) {
        var _this = this;
        var _a;
        (_a = this.bcDataTableConfig.header) === null || _a === void 0 ? void 0 : _a.selection.actions.forEach(function (_selectionActions) {
            var li = document.createElement(common_constants_1.BcCommonConstants.LI_TAG);
            li.className = bc_data_table_constants_1.BcDataTableConstansts.TAB_CLASS;
            li.setAttribute(common_constants_1.BcCommonConstants.ROLE, common_constants_1.BcCommonConstants.TAB_TAG);
            var selectionAction = _this.getSelectionAction(_selectionActions);
            li.appendChild(selectionAction);
            ul.appendChild(li);
        });
    };
    BcDataTableHeaderSelectionBehavior.prototype.getSelectionAction = function (_selectionActions) {
        if (!_selectionActions.type) {
            _selectionActions.type = common_constants_1.BcCommonConstants.BUTTON_TAG;
        }
        var createAction = this.selectionActionMap[_selectionActions.type];
        if (createAction) {
            return createAction(_selectionActions);
        }
    };
    BcDataTableHeaderSelectionBehavior.prototype.createButtonAction = function (_selectionActions) {
        var button = document.createElement(common_constants_1.BcCommonConstants.BUTTON_TAG);
        button.classList.add(bc_data_table_constants_1.BcDataTableConstansts.BC_BUTTON_CLASS);
        button.classList.add(bc_data_table_constants_1.BcDataTableConstansts.BC_BUTTON_HUG_CLASS);
        button.classList.add(bc_data_table_constants_1.BcDataTableConstansts.BC_BUTTON_SMALL_CLASS);
        this.addVariationToButton(button, _selectionActions.variation);
        var span = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        span.textContent = _selectionActions.text;
        button.appendChild(span);
        var icon = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        icon.classList.add(bc_data_table_constants_1.BcDataTableConstansts.ICON_CLASS);
        icon.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.ARIA_HIDDEN, String(common_constants_1.BcCommonConstants.TRUE));
        icon.textContent = bc_data_table_constants_1.BcDataTableConstansts.ICON_TIMES;
        button.appendChild(icon);
        button.setAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID, _selectionActions.actionId);
        button.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.headerHandleActionClick.bind(this));
        return button;
    };
    BcDataTableHeaderSelectionBehavior.prototype.addVariationToButton = function (button, variation) {
        if (variation === void 0) { variation = bc_data_table_constants_1.BcDataTableConstansts.PRIMARY_BUTTON_TYPE; }
        button.classList.add(bc_data_table_constants_1.BcDataTableConstansts.BC_BUTTON_CLASS + '-' + variation);
    };
    BcDataTableHeaderSelectionBehavior.prototype.createLinkAction = function (_selectionActions) {
        var link = document.createElement(common_constants_1.BcCommonConstants.HREF_TAG);
        link.classList.add(common_constants_1.BcCommonConstants.BC_LINK_CLASS);
        link.textContent = _selectionActions.text;
        return link;
    };
    BcDataTableHeaderSelectionBehavior.prototype.checkState = function (dataTableElement) {
        if (this.bcDataTableConfig.multicheck && this.bcDataTableConfig.header) {
            setTimeout(function () {
                var resizeEvent = new Event(common_constants_1.BcCommonConstants.EVENT_RESIZE);
                window.dispatchEvent(resizeEvent);
            }, common_constants_1.COMMON_CONSTANTS_NUMBERS.N10);
            this.checkVisibility();
            this.updateSelectionSelectedLabel(dataTableElement);
        }
    };
    BcDataTableHeaderSelectionBehavior.prototype.checkVisibility = function () {
        var dataTableElement = document.getElementById(this.bcDataTableConfig.id);
        var previousElement = dataTableElement.previousElementSibling;
        if (previousElement) {
            var selectionDivContainer = previousElement.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_CLASS)[0];
            var tableHeaderContainer = document.getElementsByClassName(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_HEADER_CONTAINER)[0];
            var amountItemsSelected = this.getAmountItemsSelected();
            if (amountItemsSelected > 0) {
                selectionDivContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_SHOW_CLASS);
                tableHeaderContainer.classList.add(bc_data_table_constants_1.BcDataTableConstansts.MOBILE_SHOW_CLASS);
            }
            else {
                selectionDivContainer.classList.remove(bc_data_table_constants_1.BcDataTableConstansts.HEADER_SELECTION_SHOW_CLASS);
                tableHeaderContainer.classList.remove(bc_data_table_constants_1.BcDataTableConstansts.MOBILE_SHOW_CLASS);
            }
        }
    };
    BcDataTableHeaderSelectionBehavior.prototype.getAmountItemsSelected = function () {
        var cantidadDeChecksTrue = this.getItemsSelected();
        return cantidadDeChecksTrue.length;
    };
    BcDataTableHeaderSelectionBehavior.prototype.getItemsSelected = function () {
        var data = this.bcDataTableHeaderPaginatorBehavior.getPaginatedArray(this.bcDataTableConfig.data);
        return data.filter(function (subArray) {
            return subArray.find(function (obj) { return obj.type === common_constants_1.BcCommonConstants.CHECK; })
                && (subArray.find(function (obj) { return obj.type === common_constants_1.BcCommonConstants.CHECK; })).value === true;
        });
    };
    BcDataTableHeaderSelectionBehavior.prototype.headerHandleActionClick = function (event) {
        var clickedElement = event.target;
        var actionId = clickedElement.getAttribute(bc_data_table_constants_1.BcDataTableConstansts.CELL_ACTION_ID);
        var cantidadDeChecksTrue = this.getItemsSelected();
        this.callHeaderActions(actionId, cantidadDeChecksTrue);
    };
    return BcDataTableHeaderSelectionBehavior;
}());
exports.BcDataTableHeaderSelectionBehavior = BcDataTableHeaderSelectionBehavior;
